import { Textarea } from '@/ui/Textarea';
import { ariaDescribedByIds } from '@rjsf/utils';

import type { ChangeEvent, FocusEvent } from 'react';
import type { GenericObjectType, WidgetProps } from '@rjsf/utils';

import { Wrapper } from '../shared';

const Widget = <T, S, F>({
	disabled,
	formContext,
	id,
	onBlur,
	onChange,
	onFocus,
	options,
	placeholder,
	readonly,
	value,
}: WidgetProps<T, S, F>) => {
	const { readonlyAsDisabled = true } = formContext as GenericObjectType;

	const handleChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
		onChange(target.value === '' ? options.emptyValue : target.value);
	};

	const handleBlur = ({ target }: FocusEvent<HTMLTextAreaElement>) => onBlur(id, target.value);

	const handleFocus = ({ target }: FocusEvent<HTMLTextAreaElement>) => onFocus(id, target.value);

	return (
		<Textarea
			disabled={disabled || (readonlyAsDisabled && readonly)}
			id={id}
			name={id}
			onBlur={!readonly ? handleBlur : undefined}
			onChange={!readonly ? handleChange : undefined}
			onFocus={!readonly ? handleFocus : undefined}
			placeholder={placeholder}
			rows={options.rows || 4}
			value={value}
			aria-describedby={ariaDescribedByIds<T>(id)}
		/>
	);
};

const TextareaWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { TextareaWidget };
